import { useRef, useState } from 'react';
import { STRING_NAMES } from '@gc/shared';
import { pluck } from '../lib/audio.js';
import { haptic } from '../lib/telegram.js';

/**
 * Эталон строя: нажал струну — услышал, как она должна звучать. Настоящий
 * тюнер по микрофону здесь был бы лишним: на телефоне уже стоит приложение,
 * а сравнить на слух ребёнку полезнее — так тренируется ухо.
 */
export function Tuner(): JSX.Element {
  const [ringing, setRinging] = useState<number | null>(null);
  const timer = useRef<number | null>(null);

  function play(stringIndex: number): void {
    haptic.tap();
    pluck(stringIndex, 0, undefined, 0.6);
    setRinging(stringIndex);
    if (timer.current) window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setRinging(null), 700);
  }

  return (
    <div className="card">
      <p className="hint">
        Так звучит правильно настроенная гитара. Сравнивай со своей перед каждым занятием — струны
        от толстой к тонкой: E A D G B e.
      </p>
      <div className="strings">
        {[5, 4, 3, 2, 1, 0].map((s) => (
          <button
            key={s}
            type="button"
            className={`string-row ${ringing === s ? 'on' : ''}`}
            onClick={() => play(s)}
          >
            <span className="mono nm">
              {STRING_NAMES[s]!.label} · {STRING_NAMES[s]!.note}
            </span>
            <span className="wire" style={{ height: 1 + s * 0.5 }} />
          </button>
        ))}
      </div>
    </div>
  );
}
